import React, { useContext } from 'react';
import { AdminContext } from '../../context/AdminContext';

import styles from './styles.module.scss';

const AppFormTextArea = ({
  type = 'text',
  onChange,
  className = '',
  placeholder,
  value,
  title,
  error,
  showError = true,
  showTitle = true,
  inputWidth = '353px',
  inputHeight = '44px',
  inputStyle,
  prefixClass = styles.prefix,
  wraperClassName = '',
  prefix,
  inputTitleClass,
  rows = '5',
  cols = '350',
  disabled = false,
  onKeyDown,
}) => {
  const { themeMode } = useContext(AdminContext);
  return (
    <div className={`${styles.container}${` `}${className} `}>
      {showTitle == true && (
        <p className={inputTitleClass ? inputTitleClass : styles.inputTitle}>
          {title}
        </p>
      )}
      <textarea
        type={type}
        className={`${inputStyle ? inputStyle : styles.inputStyle} ${
          styles.textareaStyle
        } ${themeMode == "dark" && 'textAreaStyle textWhite borderBlack'}`}
        onChange={onChange}
        placeholder={placeholder}
        value={value}
        rows={rows}
        cols={cols}
        disabled={disabled}
        onKeyDown={onKeyDown}
      />
      {prefix && <div className={prefixClass}>{prefix}</div>}

      {showError == true && (
        <p className={`${styles.inputError} preserveWhitethemeMode`}>
          {error}
        </p>
      )}
    </div>
  );
};

export default AppFormTextArea;
